import React from 'react';

/** Passthrough — framer-motion page transitions removed in R1 React 19 prep. */
const PageTransitionWrapper = ({ children }) => children;

export default PageTransitionWrapper;
